window.addEventListener("DOMContentLoaded", async () => {
    const panelRoadtripList         = document.querySelector("#roadtrips-list");

    const roadtripPanelContent      = document.querySelector('.roadtrip-panel-content');
    const draggableList             = roadtripPanelContent.querySelector('#roadtrip-draggable');
    const intermediaryStepContainer = draggableList.querySelector("#roadtrip-steps");

    const modal                     = document.getElementById("modal-upsert-roadtrip");
    const overlay                   = document.getElementById("overlay");
    const closeModalButton          = modal.querySelector("#close-modal");

    const displaySaveModal          = roadtripPanelContent.querySelector("#display-save-modal");
    const createNewRoadtrip         = roadtripPanelContent.querySelector("#reset-to-new-roadtrip");

    const addStepButton             = draggableList.querySelector('#add-roadtrip-step');
    const displayTampon             = roadtripPanelContent.querySelector('#displayTampon');
    const tunnel                    = roadtripPanelContent.querySelector('#tunnelSlider');

    const inputRoadtripName         = modal.querySelector("#roadtrip_name");
    const inputRoadtripDescription  = modal.querySelector("#roadtrip_description");
    const saveRoadtripButton        = modal.querySelector("#save-current-roadtrip");

    window.shouldUpdateStorage= true;
    window.currentRoadtrip = localStorage.getItem(window.localStorageKey)
        ? JSON.parse(localStorage.getItem(window.localStorageKey))
        : window.defaultRoadtrip;

    // session storage manager
    window.addEventListener('storage', async (e) => {
        if (e.key === window.localStorageKey && window.shouldUpdateStorage) {
            const sessionVal = JSON.parse(e.newValue);

            if (sessionVal['data']) {
                await buildRoadtripForm(sessionVal);
                window.addWaypointsToMapbox();
            }
        }
    });

    if (displaySaveModal) {
        displaySaveModal.addEventListener('click', () => {
            overlay.classList.add('visible');
            modal.classList.add('visible');
        });
    }

    closeModalButton.addEventListener('click', () => {
        modal.classList.remove('visible');
        overlay.classList.remove('visible');
    })

    overlay.addEventListener('click', () => {
       modal.classList.remove('visible');
       overlay.classList.remove('visible');
    });

    displayTampon.innerHTML = tunnel.value + ' km';
    tunnel.addEventListener('change', () => {
        displayTampon.innerHTML = tunnel.value + ' km';
    });

    addStepButton.addEventListener('click', () => {
        if (window.waypointsNumber < window.maxMapWaypoints) {
            window.waypointsNumber++;

            intermediaryStepContainer.appendChild(
                window.getStepTemplate(2, '', '')
            );
        }

        if (window.waypointsNumber === window.maxMapWaypoints) {
            addStepButton.classList.add('hidden');
        }
    });

    saveRoadtripButton.addEventListener('click', async () => {
        window.currentRoadtrip.name = inputRoadtripName.value;
        window.currentRoadtrip.description = inputRoadtripDescription.value;

        window.updateCurrentRoadtrip(window.currentRoadtrip);

        const response = await window.updateUserRoadtrip(window.currentRoadtrip);
        const content = await response.json();

        modal.classList.remove('visible');
        overlay.classList.remove('visible');

        if (response.status === 200 && content.data) {
            const roadtrip = content.data.data.roadtrip;
            toastr.success(content.data.message);

            window.updateCurrentRoadtrip(roadtrip);

            const roadtripElement = panelRoadtripList.querySelector("[data-roadtrip-id='" + roadtrip.id + "']");
            if (roadtripElement) {
                roadtripElement.querySelector('.title').textContent = roadtrip.name;
                const roadtripCountEl = window.getStepCount(
                    roadtrip.data.startStep,
                    roadtrip.data.endStep,
                    roadtrip.data.steps
                );
                const roadtripDistanceEl = roadtrip.data.distance ? ', ' + roadtrip.data.distance + ' km' : ''
                roadtripElement.querySelector('.info').innerHTML = roadtripCountEl + ' étape(s)' + roadtripDistanceEl;
            } else {
                panelRoadtripList.insertAdjacentHTML("afterbegin", window.getRoadtripTemplate(roadtrip));
            }
        } else {
            toastr.error("Une erreur est survenu lors de la sauvegarde de votre roadtrip, veuillez essayer ultérieurement");
        }
        window.openPanel('panel-roadtrip-list');
    });

    createNewRoadtrip.addEventListener('click', async () => {
        inputRoadtripName.value = window.defaultRoadtripName;
        inputRoadtripDescription.value = window.defaultRoadtripDescription;
        const emptyRoadtrip = structuredClone(window.defaultRoadtrip);

        window.updateCurrentRoadtrip(emptyRoadtrip);
        await buildRoadtripForm(emptyRoadtrip).then(() => {});
        window.removeRoutesFromMapboxDirections();
    });

    draggableList.addEventListener("mousedown", function(e){
        let target = e.target;

        if (target.classList.contains('intermediate-delete-icon')) {
            target.parentNode.remove();
            window.waypointsNumber--;

            if (window.waypointsNumber < window.maxMapWaypoints) {
                addStepButton.classList.remove('hidden');
            }

            window.updateRoadtripStorage();
            window.addWaypointsToMapbox();
        }
    });

    // ROADTRIP
    const getCoordinatesWithLabel = async (label) => {
        return await window.mapboxGetGeocodingCoordinatesByText(label, 1)
            .then(res => res.json())
            .then(data => {
                return data.features[0].geometry.coordinates;
            });
    }

    window.updateRoadtripStorage = () => {
        const steps = Array.from(draggableList.querySelectorAll('.step-input'));
        const roadtripData = { startStep: {}, endStep: {}, steps: [] };

        roadtripData.startStep = {
            label: steps[0].value,
            position: steps[0].getAttribute('coordinates')
        }

        roadtripData.endStep = {
            label: steps[steps.length - 1].value,
            position: steps[steps.length - 1].getAttribute('coordinates')
        }

        steps.shift();
        steps.pop();

        steps.forEach((step) => {
            roadtripData.steps.push({
                label: step.value,
                position: step.getAttribute('coordinates')
            });
        });

        window.currentRoadtrip.data = roadtripData;
        window.updateCurrentRoadtrip(window.currentRoadtrip);
    };

    const buildRoadtripForm = async (roadtrip) => {
        const previousInputsNode = draggableList.querySelectorAll('.draggable');
        previousInputsNode.forEach((el) => {
            el.remove();
        });

        if (roadtrip['data']) {
            const roadtripData = roadtrip['data'];

            let startStepLabel = '';
            let startStepPosition = '';
            let endStepLabel = '';
            let endStepPosition = '';

            if (roadtripData['startStep'] && roadtripData['startStep']['label']) {
                const firstStep = roadtripData['startStep'];
                startStepLabel = firstStep['label'];
                startStepPosition = await window.orderCoordinatesWithLonFirst(firstStep['position'], firstStep['label']);
            }

            if (roadtripData['endStep'] && roadtripData['endStep']['label']) {
                const lastStep = roadtripData['endStep'];
                endStepLabel = lastStep['label'];
                endStepPosition = await window.orderCoordinatesWithLonFirst(lastStep['position'], lastStep['label']);
            }

            draggableList.insertBefore(
                window.getStepTemplate(1, startStepLabel, startStepPosition),
                intermediaryStepContainer
            );

            draggableList.appendChild(
                window.getStepTemplate(3, endStepLabel, endStepPosition)
            );

            if (roadtripData['steps']) {
                for (const step of roadtripData['steps']) {
                    const stepLabel = step['label'];
                    if (step['label'] && step['label'].length > 0) {
                        let stepCoordinates = await window.orderCoordinatesWithLonFirst(step['position'], step['label']);

                        intermediaryStepContainer.appendChild(
                            window.getStepTemplate(2, stepLabel, stepCoordinates)
                        );
                    }
                }
            }

            window.updateRoadtripStorage();
        }
    }

    window.addPoiToRoadtrip = (step) => {
        const roadtrip = window.currentRoadtrip.data;
        const steps = roadtrip.steps;

        if (!window.stepIsValid(step)) {
            toastr.error("Une erreur est survenu.");
        }

        const stepLabel = step['label'];
        const stepCoordinates = step['position'];

        const rep = window.countIdenticalStep(roadtrip, steps, stepLabel);

        if (rep >= 2) {
            toastr.error('Impossible d\'ajouter le poi dans votre roadtrip plus de deux fois.');
            return;
        }

        if (window.waypointsNumber < window.maxMapWaypoints) {
            const startStepContainer = draggableList.querySelector('#start-step');

            if (roadtrip?.startStep?.label?.length === 0) {
                roadtrip.startStep = {
                    label: stepLabel,
                    position: stepCoordinates
                }

                window.setMultipleAttributesOnElement(
                    startStepContainer.querySelector('.step-input'),
                    {
                        value: stepLabel,
                        coordinates: stepCoordinates.replace("|", ',')
                    }
                );
            } else if (roadtrip?.endStep?.label?.length === 0) {
                const endStepContainer = draggableList.querySelector('#end-step');

                roadtrip.endStep = {
                    label: stepLabel,
                    position: stepCoordinates
                }

                window.setMultipleAttributesOnElement(
                    endStepContainer.querySelector('.step-input'),
                    {
                        value: stepLabel,
                        coordinates: stepCoordinates.replace("|", ',')
                    }
                );
            } else {
                steps.push({
                    label: stepLabel,
                    position: stepCoordinates
                });

                intermediaryStepContainer.appendChild(
                    window.getStepTemplate(2, stepLabel, stepCoordinates.replace("|", ','))
                );

                window.waypointsNumber++;
            }
            toastr.success('Le poi a bien été ajouté dans votre roadtrip');
        } else if (roadtrip?.endStep?.label?.length === 0) {
            const endStepContainer = draggableList.querySelector('#end-step');

            roadtrip.endStep = {
                label: stepLabel,
                position: stepCoordinates
            }

            window.setMultipleAttributesOnElement(
                endStepContainer.querySelector('.step-input'),
                {
                    value: stepLabel,
                    coordinates: stepCoordinates.replace("|", ',')
                }
            );
        }

        window.updateRoadtripStorage();
        window.addWaypointsToMapbox();
        window.openPanel('panel-roadtrip');
    }

    if (panelRoadtripList) {
        panelRoadtripList.addEventListener('click', async (e) => {
            const target = e.target.closest('.roadtrips-element');

            if (target) {
                const roadtrip = JSON.parse(target.getAttribute('data-roadtrip') ?? "");

                await buildRoadtripForm({
                    id: roadtrip.id,
                    name: roadtrip.name,
                    description: roadtrip.description,
                    data: roadtrip.data
                }).then(() => {});
                updateRoadtripSaveForm({name: roadtrip.name, description: roadtrip.description});

                window.addWaypointsToMapbox();
                window.openPanel('panel-roadtrip');
            }
        });
    }

    const updateRoadtripSaveForm = (roadtrip) => {
        inputRoadtripName.value = roadtrip.name ?? "";
        inputRoadtripDescription.value = roadtrip.description ?? "";
    };

    window.updateCurrentRoadtrip = (roadtrip, allowEventToSpread = false) => {
        if (!allowEventToSpread) {
            window.shouldUpdateStorage = false;
        }

        localStorage.setItem(window.localStorageKey, JSON.stringify(roadtrip));
        window.currentRoadtrip = roadtrip;

        if (!allowEventToSpread) {
            window.shouldUpdateStorage = true;
        }
    }

    window.orderCoordinatesWithLonFirst = async (position, label) => {
        let coordinates = '';
        let positionArray = [];

        if (!position?.length > 0) {
            positionArray = await getCoordinatesWithLabel(label);
        }

        if (typeof position === 'string' || position instanceof String) {
            positionArray = position.replace('|', ',').split(',');
        }

        if (Array.isArray(position)) {
            positionArray = position;
        }

        if (positionArray.length > 0) {
            coordinates = positionArray[0] > 0
                ? positionArray[1] + ',' + positionArray[0]
                : positionArray[0] + ',' + positionArray[1]
        }

        return coordinates;
    }

    if (window.currentRoadtrip) {
        await buildRoadtripForm(window.currentRoadtrip);
        updateRoadtripSaveForm(window.currentRoadtrip);
        window.openPanel('panel-roadtrip');
    }
});